import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "mention-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "dropdown"
}
const _hoisted_3 = ["onMousedown"]
const _hoisted_4 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showDropdown)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: user.id,
              onMousedown: _withModifiers(($event: any) => (_ctx.selectUser(user)), ["prevent"]),
              class: _normalizeClass({ highlighted: index == _ctx.highlightedIndex })
            }, _toDisplayString(user.name), 43, _hoisted_3))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("input", {
      disabled: _ctx.disabled,
      type: "text",
      placeholder: "Text",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.text) = $event)),
      style: _normalizeStyle(_ctx.inputStyles),
      onKeydown: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onKeyDown && _ctx.onKeyDown(...args)))
    }, null, 44, _hoisted_4), [
      [_vModelText, _ctx.text]
    ])
  ]))
}